var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGooglePlayBadge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 135,
    height: 41,
    viewBox: "0 0 135 41",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "44ez5o3nva",
    d: "M0.06 0L135 0 135 39.94 0.06 39.94z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "1gz1w1w3vc",
    d: "M5.013 9.274L.888 5.146v-.292L5.014.727l.094.053 4.888 2.778c1.397.793 1.397 2.091 0 2.884L5.108 9.22l-.095.054"
  }), /*#__PURE__*/React.createElement("path", {
    id: "savsczaubf",
    d: "M17.108 4.22L12.888 0 .435 12.453c.46.487 1.22.547 2.077.061L17.108 4.22"
  }), /*#__PURE__*/React.createElement("path", {
    id: "b0nxklytbi",
    d: "M17.108 8.78L2.512.486C1.655-.001.895.06.435.547L12.888 13l4.22-4.22"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "5zobk3kwmd",
    x1: "80.749%",
    x2: "-157.311%",
    y1: "49.996%",
    y2: "49.996%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#EC942D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FBDE1E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ryqqjjaw1g",
    x1: "86.244%",
    x2: "-50.141%",
    y1: "30.901%",
    y2: "136.012%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#DD4245"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#B72162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "lbrgzbbauj",
    x1: "-50.749%",
    x2: "60.606%",
    y1: "-36.484%",
    y2: "49.339%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#6CB966"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#299567"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-833 -2240) translate(833 2240) translate(0 1)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "d8f8shusyb",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#44ez5o3nva"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#0A0B09",
    d: "M130 40H5c-2.75 0-5-2.25-5-5V5c0-2.75 2.25-5 5-5h125c2.75 0 5 2.25 5 5v30c0 2.75-2.25 5-5 5",
    mask: "url(#d8f8shusyb)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9E9F9B",
    d: "M130 0H5C2.25 0 0 2.25 0 5v30c0 2.75 2.25 5 5 5h125c2.75 0 5-2.25 5-5V5c0-2.75-2.25-5-5-5zm0 .8c2.316 0 4.2 1.884 4.2 4.2v30c0 2.316-1.884 4.2-4.2 4.2H5C2.684 39.2.8 37.316.8 35V5C.8 2.684 2.684.8 5 .8h125z",
    mask: "url(#d8f8shusyb)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFE",
    d: "M106.936 30h1.866V17.498h-1.866V30zm16.807-7.998l-2.139 5.42h-.064l-2.22-5.42h-2.01l3.33 7.575-1.899 4.214h1.946l5.131-11.789h-2.075zM113.16 28.58c-.61 0-1.463-.306-1.463-1.061 0-.965 1.062-1.335 1.979-1.335.819 0 1.206.177 1.704.418-.145 1.158-1.142 1.978-2.22 1.978zm.226-6.852c-1.351 0-2.75.596-3.329 1.915l1.656.691c.354-.691 1.013-.917 1.705-.917.965 0 1.946.579 1.962 1.608v.129c-.338-.193-1.062-.482-1.947-.482-1.785 0-3.602.981-3.602 2.814 0 1.673 1.464 2.751 3.104 2.751 1.254 0 1.947-.563 2.38-1.223h.065v.965h1.802v-4.793c0-2.219-1.658-3.458-3.796-3.458zm-11.532 1.796H99.2v-4.285h2.654c1.395 0 2.187 1.155 2.187 2.142 0 .969-.792 2.143-2.187 2.143zm-.048-6.026h-4.471V30H99.2v-4.736h2.606c2.068 0 4.101-1.497 4.101-3.883 0-2.385-2.033-3.883-4.101-3.883zM77.425 28.582c-1.289 0-2.368-1.079-2.368-2.561 0-1.499 1.079-2.594 2.368-2.594 1.272 0 2.271 1.095 2.271 2.594 0 1.482-.999 2.561-2.271 2.561zm2.142-5.88h-.064c-.419-.499-1.225-.951-2.239-.951-2.127 0-4.077 1.87-4.077 4.27 0 2.384 1.95 4.237 4.077 4.237 1.014 0 1.82-.451 2.239-.967h.064v.612c0 1.628-.87 2.497-2.271 2.497-1.144 0-1.853-.821-2.143-1.514l-1.627.677c.467 1.127 1.707 2.513 3.77 2.513 2.191 0 4.044-1.289 4.044-4.431v-7.636h-1.773v.693zM82.629 30h1.868V17.498h-1.868V30zm4.623-4.124c-.048-1.644 1.273-2.481 2.223-2.481.742 0 1.37.371 1.58.902l-3.803 1.579zm5.8-1.418c-.355-.95-1.434-2.707-3.641-2.707-2.191 0-4.012 1.725-4.012 4.254 0 2.384 1.805 4.253 4.221 4.253 1.949 0 3.077-1.192 3.545-1.885l-1.45-.967c-.484.709-1.144 1.176-2.095 1.176-.95 0-1.627-.435-2.061-1.289l5.686-2.352-.193-.483zm-45.308-1.401v1.804h4.317c-.129 1.015-.467 1.756-.983 2.271-.628.629-1.611 1.322-3.334 1.322-2.659 0-4.737-2.143-4.737-4.801 0-2.658 2.078-4.801 4.737-4.801 1.434 0 2.48.563 3.254 1.289l1.273-1.273c-1.08-1.031-2.513-1.821-4.527-1.821-3.642 0-6.703 2.965-6.703 6.606 0 3.64 3.061 6.605 6.703 6.605 1.965 0 3.447-.645 4.607-1.853 1.192-1.192 1.563-2.867 1.563-4.221 0-.418-.032-.805-.097-1.127h-6.073zm11.078 5.525c-1.288 0-2.4-1.063-2.4-2.577 0-1.531 1.112-2.578 2.4-2.578 1.289 0 2.401 1.047 2.401 2.578 0 1.514-1.112 2.577-2.401 2.577zm0-6.831c-2.352 0-4.269 1.789-4.269 4.254 0 2.449 1.917 4.253 4.269 4.253 2.353 0 4.27-1.804 4.27-4.253 0-2.465-1.917-4.254-4.27-4.254zm9.314 6.831c-1.289 0-2.401-1.063-2.401-2.577 0-1.531 1.112-2.578 2.401-2.578 1.289 0 2.4 1.047 2.4 2.578 0 1.514-1.111 2.577-2.4 2.577zm0-6.831c-2.352 0-4.269 1.789-4.269 4.254 0 2.449 1.917 4.253 4.269 4.253 2.352 0 4.269-1.804 4.269-4.253 0-2.465-1.917-4.254-4.269-4.254z",
    transform: "translate(-833 -2240) translate(833 2240) translate(0 1)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#60C2E3",
    d: "M10.435 7.547c-.291.308-.462.785-.462 1.404v22.098c0 .618.171 1.096.462 1.404l.074.072 12.379-12.379v-.292L10.509 7.475l-.074.072",
    transform: "translate(-833 -2240) translate(833 2240) translate(0 1)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-833 -2240) translate(833 2240) translate(0 1) translate(22 15)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "rpfjcqevve",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#1gz1w1w3vc"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#5zobk3kwmd)",
    d: "M5.013 9.274L.888 5.146v-.292L5.014.727l.094.053 4.888 2.778c1.397.793 1.397 2.091 0 2.884L5.108 9.22l-.095.054",
    mask: "url(#rpfjcqevve)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-833 -2240) translate(833 2240) translate(0 1) translate(10 20)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "92wdweo0uh",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#savsczaubf"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#ryqqjjaw1g)",
    d: "M17.108 4.22L12.888 0 .435 12.453c.46.487 1.22.547 2.077.061L17.108 4.22",
    mask: "url(#92wdweo0uh)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-833 -2240) translate(833 2240) translate(0 1) translate(10 7)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "wxyv057oak",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b0nxklytbi"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#lbrgzbbauj)",
    d: "M17.108 8.78L2.512.486C1.655-.001.895.06.435.547L12.888 13l4.22-4.22",
    mask: "url(#wxyv057oak)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFE",
    d: "M43.011 13.134c-.436 0-.808-.121-1.115-.365-.307-.243-.526-.584-.653-1.026l.704-.293c.178.631.545.946 1.097.946.358 0 .633-.115.825-.347.193-.232.29-.546.29-.943V7h.771v4.089c0 .654-.181 1.158-.541 1.513-.36.355-.819.532-1.378.532",
    transform: "translate(-833 -2240) translate(833 2240) translate(0 1)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFFFFE",
    strokeWidth: 0.2,
    d: "M43.011 13.134c-.436 0-.808-.121-1.115-.365-.307-.243-.526-.584-.653-1.026l.704-.293c.178.631.545.946 1.097.946.358 0 .633-.115.825-.347.193-.232.29-.546.29-.943V7h.771v4.089c0 .654-.181 1.158-.541 1.513-.36.355-.819.532-1.378.532z",
    transform: "translate(-833 -2240) translate(833 2240) translate(0 1)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFE",
    d: "M49.706 7.737L46.974 7.737 46.974 9.64 49.438 9.64 49.438 10.36 46.974 10.36 46.974 12.263 49.706 12.263 49.706 13 46.203 13 46.203 7 49.706 7 49.706 7.737",
    transform: "translate(-833 -2240) translate(833 2240) translate(0 1)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFFFFE",
    strokeWidth: 0.2,
    d: "M49.706 7.737L46.974 7.737 46.974 9.64 49.438 9.64 49.438 10.36 46.974 10.36 46.974 12.263 49.706 12.263 49.706 13 46.203 13 46.203 7 49.706 7z",
    transform: "translate(-833 -2240) translate(833 2240) translate(0 1)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFE",
    d: "M52.957 13L52.186 13 52.186 7.737 50.51 7.737 50.51 7 54.633 7 54.633 7.737 52.957 7.737 52.957 13",
    transform: "translate(-833 -2240) translate(833 2240) translate(0 1)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFFFFE",
    strokeWidth: 0.2,
    d: "M52.957 13L52.186 13 52.186 7.737 50.51 7.737 50.51 7 54.633 7 54.633 7.737 52.957 7.737z",
    transform: "translate(-833 -2240) translate(833 2240) translate(0 1)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFE",
    d: "M55.271 13L55.271 12.195 58.463 7.737 55.405 7.737 55.405 7 59.36 7 59.36 7.805 56.167 12.263 59.394 12.263 59.394 13 55.271 13",
    transform: "translate(-833 -2240) translate(833 2240) translate(0 1)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFFFFE",
    strokeWidth: 0.2,
    d: "M55.271 13L55.271 12.195 58.463 7.737 55.405 7.737 55.405 7 59.36 7 59.36 7.805 56.167 12.263 59.394 12.263 59.394 13z",
    transform: "translate(-833 -2240) translate(833 2240) translate(0 1)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFE",
    d: "M62.544 13L61.773 13 61.773 7.737 60.097 7.737 60.097 7 64.22 7 64.22 7.737 62.544 7.737 62.544 13",
    transform: "translate(-833 -2240) translate(833 2240) translate(0 1)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFFFFE",
    strokeWidth: 0.2,
    d: "M62.544 13L61.773 13 61.773 7.737 60.097 7.737 60.097 7 64.22 7 64.22 7.737 62.544 7.737z",
    transform: "translate(-833 -2240) translate(833 2240) translate(0 1)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFE",
    d: "M67.975 12.263h1.55c.296 0 .536-.104.721-.311.185-.206.276-.433.276-.679 0-.245-.094-.47-.285-.674-.189-.204-.438-.306-.746-.306h-1.516v1.97zm0-2.691h1.399c.291 0 .524-.096.7-.289.176-.192.264-.403.264-.632 0-.229-.085-.439-.256-.629-.17-.19-.395-.285-.674-.285h-1.433v1.835zM67.204 13V7h2.17c.47 0 .876.155 1.22.465.343.31.515.7.515 1.169 0 .285-.074.536-.222.754-.148.218-.345.383-.591.495v.033c.296.101.539.274.729.519.19.247.285.532.285.855 0 .492-.18.9-.541 1.224-.36.324-.786.486-1.278.486h-2.287z",
    transform: "translate(-833 -2240) translate(833 2240) translate(0 1)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFFFFE",
    strokeWidth: 0.2,
    d: "M67.975 12.263h1.55c.296 0 .536-.104.721-.311.185-.206.276-.433.276-.679 0-.245-.094-.47-.285-.674-.189-.204-.438-.306-.746-.306h-1.516v1.97zm0-2.691h1.399c.291 0 .524-.096.7-.289.176-.192.264-.403.264-.632 0-.229-.085-.439-.256-.629-.17-.19-.395-.285-.674-.285h-1.433v1.835zM67.204 13V7h2.17c.47 0 .876.155 1.22.465.343.31.515.7.515 1.169 0 .285-.074.536-.222.754-.148.218-.345.383-.591.495v.033c.296.101.539.274.729.519.19.247.285.532.285.855 0 .492-.18.9-.541 1.224-.36.324-.786.486-1.278.486h-2.287z",
    transform: "translate(-833 -2240) translate(833 2240) translate(0 1)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFE",
    d: "M75.852 7.737L73.119 7.737 73.119 9.64 75.583 9.64 75.583 10.36 73.119 10.36 73.119 12.263 75.852 12.263 75.852 13 72.349 13 72.349 7 75.852 7 75.852 7.737",
    transform: "translate(-833 -2240) translate(833 2240) translate(0 1)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFFFFE",
    strokeWidth: 0.2,
    d: "M75.852 7.737L73.119 7.737 73.119 9.64 75.583 9.64 75.583 10.36 73.119 10.36 73.119 12.263 75.852 12.263 75.852 13 72.349 13 72.349 7 75.852 7z",
    transform: "translate(-833 -2240) translate(833 2240) translate(0 1)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFE",
    d: "M77.059 13L77.83 13 77.83 7 77.059 7z",
    transform: "translate(-833 -2240) translate(833 2240) translate(0 1)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFFFFE",
    strokeWidth: 0.2,
    d: "M77.059 13L77.83 13 77.83 7 77.059 7z",
    transform: "translate(-833 -2240) translate(833 2240) translate(0 1)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGooglePlayBadge);
export default __webpack_public_path__ + "static/media/google-play-badge.5bab2ca499226ef22ac081182aab5b8a.svg";
export { ForwardRef as ReactComponent };